import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationStratalotAvancementApiService } from './organization-stratalot-avancement-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationStratalotAvancementApiService extends GeneratedOrganizationStratalotAvancementApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
